
  <!--
    @deprecated after using the <gen-dynamic-form-table> infrastructure in <curation-editor-items-container.component>
   -->

  <section class="form-item override-item-as-row card-layout" [ngClass]="{'item-deleted':deleted}">
  <div class="panels-container">
    <div class="left-panel results-pane-value">
      <gen-dynamic-form class="form_data"
        [ngClass]="{'diff_marker': itemDeletedShowChanged}"
        [listenToDataChange]="true"
        [formData]="_itemDetails"
        [formName]="formName"
        [formVertical]="vertical"
        (formChange)="updateForm($event.form)"
        [requiredMessage]="'Required information missing'"
        [disabled]="readOnly || deleted"
        [updateOnBlur]="false"
        [updatedFieldsContext]="updatedFieldsContext"
        [editMode]="!((inlineEdit || addNewMode) && !readOnly)"
        [submitted]="submitted"
        (validateChange)="validationEvent($event)">
      </gen-dynamic-form>

      <div class="right-panel">
        <gen-button *ngIf="!readOnly"
                    [ngClass]="uniqueButtonName"
                    (click)="deleteItem()"
                    [type]="'quite'"
                    [text]="''"
                    [iconClass]="'icon__trash'"
                    [disabled]="deleteDisabled">
        </gen-button>
    </div>
    </div>
  </div>
</section>

